import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE =
  "Calculatrice longueur du côté du carré - Calcul à partir du périmètre ou de l'aire";
const DESCRIPTION =
  "Calculatrice longueur du côté du carré - Calcul à partir du périmètre ou de l pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "longueur du côté du carré calcul à partir du périmètre ou de l, calculatrice longueur du côté du carré calcul à partir du périmètre ou de l, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/square-side-length";
function SquareSideLengthCalculator() {
  const [perimeter, setPerimeter] = useState("");
  const [area, setArea] = useState("");
  const [sideLength, setSideLength] = useState("");
  const [calculationType, setCalculationType] = useState("perimeter");
  const [error, setError] = useState("");

  const handleCalculationTypeChange = (newCalculationType) => {
    setCalculationType(newCalculationType);
    if (newCalculationType === "perimeter") {
      setArea("");
    }
    if (newCalculationType === "area") {
      setPerimeter("");
    }
  };

  const handleCalculate = () => {
    if ((!perimeter && !area) || (perimeter && area)) {
      setError("Veuillez entrer soit le périmètre, soit l'aire uniquement");
      setSideLength("");
      return;
    }
    if (calculationType === "perimeter") {
      if (perimeter) {
        const perimeterValue = parseFloat(perimeter);
        if (isNaN(perimeterValue) || perimeterValue <= 0) {
          setError("Veuillez entrer une valeur valide et positive pour le périmètre");
          setSideLength("");
          return;
        }
        const length = perimeterValue / 4;
        setSideLength(length.toFixed(2));
        setError("");
      }
    } else if (calculationType === "area") {
      if (area) {
        const areaValue = parseFloat(area);
        if (isNaN(areaValue) || areaValue <= 0) {
          setError("Veuillez entrer une valeur valide et positive pour l'aire");
          setSideLength("");
          return;
        }
        const length = Math.sqrt(areaValue);
        setSideLength(length.toFixed(2));
        setError("");
      }
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer la longueur du côté du carré</h2>
                <p>
                  La longueur du côté du carré peut être calculée à partir du périmètre
                  ou de l'aire par les formules suivantes :
                </p>
                <p>Si vous avez le périmètre : Côté = Périmètre / 4</p>
                <p>Si vous avez l'aire : Côté = Racine carrée de l'aire</p>
                <p>Entrez soit le périmètre, soit l'aire pour calculer la longueur du côté.</p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  Voulez-vous calculer le côté à partir du périmètre ou de l'aire ?
                  <div className="form-check">
                    <input
                      type="radio"
                      name="calculationType"
                      id="perimeterRadio"
                      value="perimeter"
                      checked={calculationType === "perimeter"}
                      onChange={() => handleCalculationTypeChange("perimeter")}
                    />
                    <label className="form-check-label" htmlFor="perimeterRadio">
                      Périmètre
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      name="calculationType"
                      id="areaRadio"
                      value="area"
                      checked={calculationType === "area"}
                      onChange={() => handleCalculationTypeChange("area")}
                    />
                    <label className="form-check-label" htmlFor="areaRadio">
                      Aire
                    </label>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Périmètre (cm)</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Périmètre"
                      value={perimeter}
                      onChange={(e) => setPerimeter(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                      disabled={calculationType === "area"}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Aire (cm²)</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Aire"
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                      disabled={calculationType === "perimeter"}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculate}
                  >
                    Calculer la longueur du côté
                  </button>
                </div>
                <br />
                <div>
                  {error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      Erreur : {error}
                    </p>
                  ) : (
                    <>
                      {sideLength !== "" && (
                        <p className="p-3 mb-2 bg-success text-white">
                          Longueur du côté du carré : {sideLength} cm
                        </p>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Le côté du carré : formule et calcul</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Un carré a quatre côtés égaux. Deux formules permettent de trouver la longueur d'un côté :
                      </p>
                      <ul>
                        <li>À partir du <strong>périmètre</strong> : côté = périmètre ÷ 4</li>
                        <li>À partir de l&apos;<strong>aire</strong> : côté = √aire</li>
                      </ul>
                      <p>
                        Exemple : si l'aire est 49 cm², le côté mesure √49 = <strong>7 cm</strong>.
                        Si le périmètre est 28 cm, le côté mesure 28 ÷ 4 = <strong>7 cm</strong>.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Propriétés du carré</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le carré est un quadrilatère régulier : tous ses angles sont droits (90°)
                        et tous ses côtés sont égaux. Ses diagonales sont égales, se bisectent
                        à angle droit et mesurent chacune côté × √2.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Applications pratiques</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Ce calcul est utile en architecture, décoration intérieure et jardinage.
                        Pour carréler une pièce carrée de 25 m², chaque côté mesure √25 = 5 m.
                        En couture, pour un tissu carré de 1 600 cm², le côté est de 40 cm.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default SquareSideLengthCalculator;
